export default function RenewIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.25 9.75h-4.5A.75.75 0 0 1 3 9V4.5a.75.75 0 0 1 1.5 0v2.236C5.95 5.1 8.495 3 12 3c4.014 0 6.43 2.37 6.53 2.47a.75.75 0 1 1-1.059 1.063C17.446 6.506 15.367 4.5 12 4.5c-3.281 0-5.647 2.31-6.803 3.75H8.25a.75.75 0 0 1 0 1.5Zm12 4.5h-4.5a.75.75 0 1 0 0 1.5h3.052c-1.155 1.44-3.52 3.75-6.802 3.75-3.367 0-5.446-2.007-5.471-2.032a.75.75 0 0 0-1.06 1.063C5.571 18.63 7.986 21 12 21c3.505 0 6.05-2.1 7.5-3.736V19.5a.75.75 0 1 0 1.5 0V15a.75.75 0 0 0-.75-.75Z"
      />
    </svg>
  );
}
